'use client';

import React from 'react';
import clsx from 'clsx';
import Marquee from 'react-fast-marquee';
import { isFilled } from '@prismicio/helpers';
import { PrismicNextImage } from '@prismicio/next';
import { ConditionalLink } from '@/app/lib/ConditionalLink';
import { RevealTitle } from '@/app/lib/RevealTitle';
import { dashify } from '@/app/lib/utils';
import styles from './clients.module.scss';
import sharedStyles from '@/app/shared.module.scss';

const Clients = ({ slice }) => {

  return (
    <div className={clsx(styles.wrapper)}>

      {/* title */}
      { isFilled.keyText(slice?.primary?.title) && (
        <div className={clsx(sharedStyles.top)}>
          <div className={clsx(sharedStyles.left)}>
            <h1 className={clsx(sharedStyles.h1, styles.h1)} id={dashify(slice?.primary?.title)}>
              <RevealTitle size='small'>{slice?.primary?.title}</RevealTitle>
            </h1>
          </div>
        </div>
      )}

      <div className={clsx(styles.clients)} style={{ backgroundColor: slice?.primary?.background_color || '#000' }}>

        <Marquee
          speed={60}
          autoFill={true}
          play={true}
          direction={slice?.primary?.direction ? (slice?.primary?.direction === 'Left' ? 'left' : 'right') : 'left'}
        >
          {slice?.primary?.clients.map((client, index) =>
              isFilled.image(client.image) && (
                <div className={clsx(styles.client)} key={index} >
                  <ConditionalLink url={client?.url?.uid || client?.url?.url} className={styles.link}>
                    <PrismicNextImage field={client.image} fallbackAlt='' className={styles.image} />
                  </ConditionalLink>
                </div>
              ),
          )}
        </Marquee>
      </div>
    </div>
  )
};

export default Clients;